import Login from './LoginContainer';
import Register from './RegisterContainer';
import Forgot from './ForgotContainer';
import Renew from './RenewContainer';

export default {
  Login,
  Register,
  Forgot,
  Renew,
};



// WEBPACK FOOTER //
// ./src/containers/auth/index.js